<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 md12>
        <h2>({{new Date().getFullYear()}}) 公司盈餘統計</h2>
        <v-progress-circular v-if="loading" indeterminate color="success"></v-progress-circular>
        <bar-chart :styles="lineChartStyles" :chart-data="yearChartData"></bar-chart>
<!--        <line-chart :styles="lineChartStyles" :chart-data="yearChartData"></line-chart>-->
      </v-flex>
    </v-layout>
    <v-layout v-if="yearChartData.datasets">
      <v-flex>
        <table border="1">
          <thead>
          <tr>
            <td>
              <span :style="{fontSize: '16px', fontWeight: 'bold'}">月份
              </span>
            </td>
            <td v-for="(text, i) of yearChartData.labels" :key="`table_key_${i}`">
                     <span :style="{fontSize: '16px', fontWeight: 'bold'}">
                    {{text}}
                  </span>
            </td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>盈餘</td>
            <td v-for="(value, i) of yearTableData" :key="`table_value_${i}`">
                  <span :style="{ color:'#000', fontSize: '16px', fontWeight: 'bold'}">
                    {{value}}
                  </span>
            </td>
          </tr>
          </tbody>
        </table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BarChart from "../utils/barChart";
import { mapActions } from 'vuex';
import { getCompanyReport } from '@/store/actions';
import LineChart from '@/pages/utils/lineChart';
import common from '@/mixins/common';
export default {
  name: 'CompanyReportChart',
  components:{
    LineChart,
    BarChart
  },
  data(){
    return {
      height: 400,
      yearChartData: {},
      yearTableData: [],
      loading: false,
    }
  },
  async created() {
    await this.loadData();
  },
  mixins:[common],
  computed: {
    lineChartStyles() {
      return {
        height: `${this.height}px`,
        position: "relative"
      };
    }
  },
  methods:{
    ...mapActions(['getCompanyReport']),
    async loadData(){
      try {
        this.loading = true;
        const res = await this.getCompanyReport({});
        const result = res.data;
        const list = result.data;
        console.log(`result = ${JSON.stringify(list)}`);
        let labels = [];
        let balanceList = [];
        this.yearTableData = [];
        let i = 1;
        for (let item of list){
          labels.push(`${i}`);
          balanceList.push(item.balance);
          this.yearTableData.push(item.balance)
          i++;
        }
        this.yearChartData = {
          labels: labels,
          datasets: [
            {
              label: '盈餘',
              backgroundColor: 'rgba(255,99,132,1)',
              data: balanceList,
              borderWidth: 1,
              categoryPercentage: 1,
            },
          ]
        }
        this.$forceUpdate();
      } catch (e) {
        this.showMessageDialog('載入失敗')
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/CompanyReportChart.vue